import React, { Component } from 'react';
import { connect } from 'react-redux';
import banner from '../../../statics/banner.jpg';
import { Link } from 'react-router-dom';
import '../index.scss';

class Banner extends Component {

  render() {

    const { head } = this.props;
    // console.log('head', head);
    
    return (
      <div className="banner-content">
        <div style={{backgroundImage: `url(${head.get('logo') ? head.get('logo') : banner })`}} className="banner-content__banner" ></div>
        <div className="banner-content__cta">
          <h1 className="banner-content__title">{ head.get('name') }</h1>
          {
            head.get('des') ? (
              <p className="banner-content__l-desc">{ head.get('des') }</p>
            ) : null
          }
          {
            head.get('en') ? (
              <p className="banner-content__l-desc">{ head.get('en') }</p>
            ) : null
          }
          <Link className="banner-content__more" to="/achievement">进入项目库 <i className="iconfont">&#xe664;</i></Link>
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  head: state.getIn(['home', 'head'])
});

export default connect(mapState, null)(Banner);
